export const WIDGET_HELP_TYPE = 'tip';
